<template>
   <div>
      <SGPRowComponent>
        <div class="p-4">
          <h4> Digite a designação ou terminal</h4>
            <form @submit.prevent="submit()">
              <SGPFormInputComponent name="designacao" type="text" placeholder="Designacao / Terminal" v-model="formulario.designacao" /> 
              <!-- <br>
              <SGPFormInputComponent name="pco_cpe_id" type="text" placeholder="CPE ID" v-model="formulario.pco_cpe_id"/> -->
              <br>
              <SGPFormBotaoComponent type="submit" color="primary" block rounded middle >
              <span>Consultar</span>
            </SGPFormBotaoComponent>
            </form>  
        </div>
      </SGPRowComponent>
      <SGPRowComponent>
        <SGPPaginacaoComponent
          class="p-4"
          :paginacao="paginacao"
          v-if="this.listagemEquipamentos.length"
          @sgpAtualizarPaginacao="realizarPaginacao"
          :key="paginacao"
        >
          <SGPTabelaComponent            
            :colunas="colunas"
            :dados="this.listagemEquipamentos"
            :filtroText="false"
            :usuarioPodeExcluir="false"
            :usuarioPodeEditar="false"
            :somenteLeitura="true" 
            @sgpTabelaModalCadastrarEmit="gerenciadorDeSelecionados"
          ></SGPTabelaComponent>
        </SGPPaginacaoComponent>

      </SGPRowComponent>
      <SGPRowComponent v-if="!listagemEquipamentos.length && this.submitForm" >
          <SGPColComponent cols="11">
            <SGPAlertaComponent class="margin-top-10">
              Nenhum resultado foi encontrado para sua pesquisa!
            </SGPAlertaComponent>
          </SGPColComponent>
      </SGPRowComponent>
      <div v-if="exibeDetalhes" class="p-4"> 
        <SGPRowComponent>
          <hr style="border: 1px solid #000; margin: 10px 0;" />
          <div class="col-6 d-flex flex-column"> 
            <div class="consulta-equipamento-subtitulo-label"> CPEID: <br> </div>
            <div class="consulta-equipamento-texto-comum"> {{ retorno.id }} </div>
          </div>

          <div class="col-6 d-flex flex-column"> 
            <div class="consulta-equipamento-subtitulo-label"> Status:  </div> 
              <div class="consulta-equipamento-texto-comum">{{ getStatus ? 'Ativo' : 'Inativo' }}</div>
          </div>
          <hr style="border: 1px solid #000; margin: 10px 0;" />
        </SGPRowComponent>
        <SGPRowComponent>
          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Tipo de equipamento</div>
              <div class="consulta-equipamento-texto-comum">{{ retorno.ctrl_cpe_modelo.ctrl_cpe_tipo_equipamento.tipo_equipamento }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Fabricante</div>
              <div class="consulta-equipamento-texto-comum">{{ retorno.ctrl_cpe_modelo.ctrl_cpe_fabricante.fabricante }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Modelo</div>
              <div class="consulta-equipamento-texto-comum">{{ retorno.ctrl_cpe_modelo.modelo }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Serial Number</div>
              <div class="consulta-equipamento-texto-comum">{{ retorno.numero_serial }}</div>
          </div>
        </SGPRowComponent>
          
        <SGPRowComponent>
          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">IP</div>
              <div class="consulta-equipamento-texto-comum"> {{ retorno.ip_equipamento }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Proprietário do CPE</div>
              <div class="consulta-equipamento-texto-comum">Embratel</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Responsável Senha</div>
              <div class="consulta-equipamento-texto-comum">Embratel</div>
          </div>

        </SGPRowComponent>
        <SGPRowComponent>
          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">CEP</div>
              <div class="consulta-equipamento-texto-comum">{{ retorno.pco_cpe_endereco.cep }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Endereço</div>
              <div class="consulta-equipamento-texto-comum">{{ retorno.pco_cpe_endereco.logradouro }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Bairro</div>
              <div class="consulta-equipamento-texto-comum">{{ retorno.pco_cpe_endereco.bairro }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Cidade/UF</div>
              <div class="consulta-equipamento-texto-comum">{{ retorno.pco_cpe_endereco.cidade }}/{{ retorno.pco_cpe_endereco.uf }}</div>
          </div>
        </SGPRowComponent>

        <SGPRowComponent>
          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Licença</div>
              <div v-if="retorno.pco_cpe_licenca" class="consulta-equipamento-texto-comum">{{ retorno.pco_cpe_licenca.licenca }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Vigência</div>
              <div v-if="retorno.pco_cpe_licenca" class="consulta-equipamento-texto-comum">{{ this.formatDateBr(retorno.pco_cpe_licenca.vigencia_licenca) }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Tipo da Licença</div>
              <div v-if="retorno.pco_cpe_licenca" class="consulta-equipamento-texto-comum">{{ retorno.pco_cpe_licenca.tipo_licenca }}</div>
          </div>

          <div class="col-3 d-flex flex-column">
              <div class="consulta-equipamento-subtitulo-label">Data da ativação</div>
              <div v-if="retorno.pco_cpe_licenca" class="consulta-equipamento-texto-comum">{{ this.formatDateBr(retorno.pco_cpe_licenca.created_at) }}</div>
          </div>
        </SGPRowComponent> 

        <SGPRowComponent>
          <hr style="border: 1px solid #000; margin: 10px 0;" />
          <div class="consulta-equipamento-subtitulo-label">Informações dos Serviços</div>
          <br>
        </SGPRowComponent>

        <SGPRowComponent  v-for="pco_cpe_servico in retorno.pco_cpe_servicos" :key="pco_cpe_servico.id">
          <div style="text-align:left !important">
            <span class="consulta-equipamento-subtitulo-label">Designação: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.designacao }}</span>
            </div>
            <div style="text-align:left !important">
                <span class="consulta-equipamento-subtitulo-label">Produto: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.servico }}</span>
            </div>

            <div style="text-align:left !important">
                <span class="consulta-equipamento-subtitulo-label">Modalidade: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.modalidade ? pco_cpe_servico.modalidade : '-'  }}</span>
            </div>

            <div style="text-align:left !important">
                <span class="consulta-equipamento-subtitulo-label">Tecnologia: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.tecnologia ? pco_cpe_servico.tecnologia : '-'  }}</span>
            </div>

            <div style="text-align:left !important">
                <span class="consulta-equipamento-subtitulo-label">Tipo de Serviço: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.tipo_servico ? pco_cpe_servico.tipo_servico : '-'  }}</span>
            </div>                            

            <div style="text-align:left !important">
                <span class="consulta-equipamento-subtitulo-label">Contrato: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.contrato }}</span>
            </div>

            <div style="text-align:left !important">
                <span class="consulta-equipamento-subtitulo-label">Conta Corrente: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.conta_corrente }}</span>
            </div>

            <div style="text-align:left !important">
                <span class="consulta-equipamento-subtitulo-label">CNPJ: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.cnpj }}</span>
            </div>

            <div style="text-align:left !important">
                <span class="consulta-equipamento-subtitulo-label">Nome Fantasia: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.nome_fantasia }}</span>
            </div>

            <div style="text-align:left !important">
                <span class="consulta-equipamento-subtitulo-label">OS SAP: </span><span class="consulta-equipamento-subtituloRedLabel">{{ pco_cpe_servico.os_sap ? pco_cpe_servico.os_sap : '-'  }}</span>
            </div>

            <hr style="border: 1px solid #000; margin: 10px 0;" />
        </SGPRowComponent>
      </div>
    </div>
</template>
<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ConsultaEquipamentoComponent',
  components: {
    
  },
  props:{
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    modosDePara: {
        type: Object,
        required: false,
        default: () => {}
      },      
  },
  data () {
    return {
        dadosLogin: {
          robo: process.env.VUE_APP_MODOS_USER,
          password: process.env.VUE_APP_MODOS_PASSWORD,        
        },  
        usuarioLogadoModos: false,
        submitForm: false,
        formulario: {
          pco_cpe_id: "",
          designacao: "",
          status: "",
          ctrl_cpe_tipo_equipamento_id: "",
          ctrl_cpe_fabricante_id: "",
          ctrl_cpe_modelo_id: "",
          numero_serial: "",
          cnpj: "",
          contrato: "",
          conta_corrente: "",
          nome_fantasia: "",
          cep: "",
          logradouro: "",
          bairro: "",
          cidade: "",
          uf: ""
        },
        retorno: {
          pco_cpe_endereco: {
              cep: null,
              logradouro: null,
              bairro: null,
              cidade: null,
              uf: null
          },
          dados : "",
          ctrl_cpe_modelo: {
            modelo: null,
            ctrl_cpe_tipo_equipamento:{
              tipo_equipamento: null
            },
            ctrl_cpe_fabricante:{
              fabricante: null
            },        
          pco_cpe_licenca:{
            licenca: null,
            vigencia_licenca: null,
            tipo_licenca: null,
            created_at: null
          },
          pco_cpe_servicos: []
          },
          mensagemPadrao: "Equipamento não localizado para designação/terminal selecionado.",
        },
        exibeDetalhes: false,
        CPEselecionados: [],  
      }
    },
  mounted() {
    if (this.value) {
      this.formulario.designacao = this.value.cpeid;
    }
    this.selecionaDesignacao();
  },
  computed: {
    ...mapGetters('automacao', [
      'listaDeCpes',
      'listaInfoCPE',
    ]),
    getStatus() {
        if(this.retorno.finalized_at == null) return true
        return false
      },
      colunas () {
        return [          
          {
            key: 'pco_cpe_id',
            label: 'ID',
            sortable: true,
            align: 'center'
          },                    
          {
            key: 'fabricante',
            label: 'Fabricante',
            sortable: true,
            align: 'center'
          },                    
          {
            key: 'modelo',
            label: 'Modelo',
            sortable: true,
            align: 'center'
          },
          {
            key: 'status',
            label: 'Status',
            sortable: true,
            align: 'center'
          },
          {
            key: 'modalGenerica',
            label: 'Visualizar',
            sortable: false
          }
        ]
      },

      listagemEquipamentos() {
        
        if (!this.listaDeCpes.data) return []
        return this.listaDeCpes.data.map(dados => {
            dados.status = dados.finalized_at == null ? 'Ativo' : 'Inativo'
            this.formulario.pco_cpe_id = dados.pco_cpe_id
            dados.modalGenerica = true
            return dados;
        });
        
      },

      paginacao () {
        if (!this.listaDeCpes.data) return {} 

        let totalRegistro = this.listaDeCpes.total

        if (this.listaDeCpes.length > this.listaDeCpes.per_page ) {
          totalRegistro++
        } else if(this.listaDeCpes.length > this.listaDeCpes.total) {
          totalRegistro = this.listaDeCpes.length
        } else {
          if(this.listaDeCpes.current_page > 1) {
            let currPage = this.listaDeCpes.current_page - 1
            let totalReg = (this.listaDeCpes.per_page * currPage) + this.listaDeCpes.length
            if(totalReg > this.listaDeCpes.total) 
            totalRegistro = totalReg
          }        
        }

        const paginate =  {
          per_page: this.listaDeCpes.per_page,
          total: totalRegistro,
          current_page: this.listaDeCpes.current_page
        }

        return paginate;
      }       
  },
    
  methods: {
    ...mapActions('automacao', [
      'listarSAIP',
      'listarCpe',
      'listarUmCpe',
      'filtrarCpes'
    ]),
    ...mapActions('modos', [
            'logarUsuario', 
            'deslogarUsuario', 
            'usuarioEstaLogado',
        ]),
        formatDateBr(val) {
        if(val != null && val.length > 0) {
            return moment(val).format('DD/MM/YYYY') // `${day}/${month}/${year}`
        }
        return '-'
      },
    gerenciadorDeSelecionados (selecionados) {
      this.formulario.pco_cpe_id = selecionados.pco_cpe_id;
      this.buscaCPEID();

    },  
    selecionaDesignacao() {
      if (this.modosDePara != undefined) { 
        if (this.modosDePara.pcoCircuitoSelecionado.designacao.includes('/IP/')) {   
            this.formulario.designacao = this.modosDePara.pcoCircuitoSelecionado.designacao;
            this.submit();
        } else if (this.modosDePara.pcoCircuitoSelecionado.terminal.toString().length === 10){
            this.formulario.designacao = this.modosDePara.pcoCircuitoSelecionado.terminal;
            this.submit();
        } else {
            this.formulario.designacao = null;
        }
      }
    
    },  
    async submit() {    
      this.exibeDetalhes = false;
      if (!await this.usuarioEstaLogado()) {
          const logar = await this.logarUsuario(this.dadosLogin);      
          if(logar.status == 200) {
              this.usuarioLogadoModos = true;
          }        
      } else {
          this.usuarioLogadoModos = true;
      }
      this.submitForm = true;

      const payload = {
         designacao: this.formulario.designacao,
         
      };
      try {
        let response = await this.filtrarCpes(payload);
        if (response && response.data) {
          this.retorno = response.data;
          console.log(this.retorno);
          this.pco_cpe_id =  this.retorno.pco_cpe_id;
        } else {
          console.error('Erro ao obter dados:', response);
        }
      } catch (error) {
        console.error('Erro na requisição:', error);
      }

      
    },
    async buscaCPEID(){
      if(this.formulario.pco_cpe_id){
          const payloadCpe = {
          designacao: this.formulario.designacao,
          pco_cpe_id: this.formulario.pco_cpe_id,
        };
        try {
          let responses  = await this.listarUmCpe(payloadCpe); // Envia como um array com um único objeto
          if (responses != null) {
            this.retorno = responses;
            this.exibeDetalhes = true;
          } else {
            console.error('Erro ao obter dados:', responses);
            this.exibeDetalhes = false;
          }
        } catch (error) {
          console.error('Erro na requisição:', error);
          this.exibeDetalhes = false;
        }
      }
    }
  }
}

</script>
<style>
.consulta-equipamento-dados {
  float: left;
  margin-bottom: 10px;
  width: calc(50% - 10px);
}

.consulta-equipamento-column {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.consulta-equipamento-titlePage {
    color: var(--neutral-dark, #51555D);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Roboto;
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px; /* 107.692% */
}

.consulta-equipamento-titleLabel {
    color: var(--neutral-dark, #51555D);
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Roboto;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 34px; /* 154.545% */
}

.consulta-equipamento-titleRedLabel {
    color: var(--Vermelho, #E3262E);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Roboto;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 34px;
}

.consulta-equipamento-titleGreenLabel {
    color: var(--support-success-dark, #006B4F);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Roboto;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 34px;
}

.consulta-equipamento-subtitulo-label {
    color: var(--neutral-dark, #51555D);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;        
    text-align: left !important;
}

.consulta-equipamento-subtituloRedLabel {
    color: var(--brand-primary-medium, #DA291C);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
}

.consulta-equipamento-textoComum {
    color: #666;
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;        
    text-align: left !important;
}

.consulta-equipamento-circuito {
    border-radius: 8px;
    border: 1px solid var(--brand-primary-medium, #DA291C);
    background: var(--neutral-lightest, #FFF);
}

.consulta-equipamento-consulta-equipamento-gray-background {
  background-color: gray;
}
</style>
